/* Arjit4Amply: Purchase panel interaction - plan/one-time selection, the Add
   to Cart button's running total, and the mobile sticky buy bar. Totals/sticky
   detail strings are pre-rendered per quantity by Liquid (data-total-1..4 and
   data-sticky-detail-1..4 on each radio/button, using the real Appstle
   allocation prices) rather than computed here, so this never needs its own
   money-formatting logic and can't drift from the shop's real currency
   formatting. */
(function () {
  document.querySelectorAll('.matre-purchase-panel').forEach(initPurchasePanel);

  function initPurchasePanel(panel) {
    var form = panel.querySelector('.matre-purchase-form');
    if (!form) return;

    var radios = Array.prototype.slice.call(form.querySelectorAll('[data-plan-radio]'));
    var onceButton = form.querySelector('[data-select-once]');
    var quantitySelect = form.querySelector('[data-quantity-select]');
    var totalEl = form.querySelector('[data-total]');
    var stickyPriceEl = panel.querySelector('[data-sticky-price]');
    var stickyDetailEl = panel.querySelector('[data-sticky-detail]');
    var renewalEl = form.querySelector('[data-renewal]');
    var qtyTextEls = form.querySelectorAll('[data-qty-text-1]');
    var quantityInput = form.querySelector('[data-quantity-input]');

    /* Arjit4Amply: optional per-quantity strings, used only by the Night
       Ritual bundle's panel (matre-night-plan-card.liquid and its one-time
       link) - elements/attributes that don't exist are simply skipped, so
       the single-product panels behave exactly as before. */
    function pick(el, prefix, quantity) {
      return el.getAttribute(prefix + quantity) || el.getAttribute(prefix + '1');
    }

    function activeSource() {
      if (onceButton && onceButton.getAttribute('aria-pressed') === 'true') return onceButton;
      var checked = radios.filter(function (radio) {
        return radio.checked;
      })[0];
      return checked || onceButton || radios[0];
    }

    function updateTotal() {
      var source = activeSource();
      if (!source) return;
      var quantity = quantitySelect ? quantitySelect.value : '1';
      /* Arjit4Amply: cart quantity = people x the plan's months (Appstle
         prices per bottle/bundle; a 3-month delivery is 3 of them). One-time
         has no data-units, so it stays 1 per person. */
      if (quantityInput) {
        var units = parseInt(source.getAttribute('data-units'), 10) || 1;
        quantityInput.value = String((parseInt(quantity, 10) || 1) * units);
      }
      var total = source.getAttribute('data-total-' + quantity) || source.getAttribute('data-total-1');
      if (totalEl) totalEl.textContent = total || '';
      if (stickyPriceEl) stickyPriceEl.textContent = pick(source, 'data-sticky-price-', quantity) || total || '';
      if (stickyDetailEl) {
        var detail = source.getAttribute('data-sticky-detail-' + quantity) || source.getAttribute('data-sticky-detail-1');
        stickyDetailEl.textContent = detail || '';
      }
      if (renewalEl) renewalEl.textContent = pick(source, 'data-renewal-', quantity) || '';
      Array.prototype.forEach.call(qtyTextEls, function (el) {
        el.textContent = pick(el, 'data-qty-text-', quantity);
      });
      if (onceButton && onceButton.hasAttribute('data-label-1')) {
        var selected = onceButton.getAttribute('aria-pressed') === 'true';
        onceButton.textContent = pick(onceButton, selected ? 'data-label-selected-' : 'data-label-', quantity);
      }
    }

    if (onceButton) {
      onceButton.addEventListener('click', function () {
        var selecting = onceButton.getAttribute('aria-pressed') !== 'true';
        onceButton.setAttribute('aria-pressed', String(selecting));
        if (selecting) {
          radios.forEach(function (radio) {
            radio.checked = false;
          });
        } else if (radios.length) {
          radios[0].checked = true;
        }
        updateTotal();
      });
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (onceButton) onceButton.setAttribute('aria-pressed', 'false');
        updateTotal();
      });
    });

    if (quantitySelect) {
      quantitySelect.addEventListener('change', updateTotal);
    }

    updateTotal();

    /* Arjit4Amply: mobile sticky buy bar visibility - ported from the
       handover package's own purchaseObserver (app.js): hidden while the
       real Add to Cart button is at least 10% visible, shown once it
       scrolls out of view in either direction. CSS keeps this bar display:
       none above 600px regardless of the "hidden" attribute's state, so the
       observer doesn't need to be width-aware itself - this only toggles
       the attribute, matre-purchase-panel.css owns the [hidden] display
       rule that acts on it. */
    var stickyBuy = panel.querySelector('[data-sticky-buy]');
    var addButton = form.querySelector('.matre-add-button');
    if (stickyBuy && addButton && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          stickyBuy.hidden = entries[0].isIntersecting;
        },
        { threshold: 0.1 }
      );
      observer.observe(addButton);
    }
  }
})();
